module.exports = __webpack_public_path__ + "img/logo-horizontal-color.a7420c2b.png";